export const getEnv = (name: string): string | undefined => {
  return window['ENV']?.[name] || process?.env?.[name] || undefined;
};
